import React from "react";
import { CustomButton } from "../customButton/CustomButton";
import EmptyGridSvg from "../../assets/svg/EmptyGridInsumo.svg";

export function EmptyState({ text, buttonText, onClick, disabled }) {
  return (
    <div className="empty-grid">
      <img className="empty-grid-svg" src={EmptyGridSvg} width="100%"></img>
      <p>{text}</p>
      <CustomButton variant={"contained"} onClick={onClick} size={"small"} disabled={disabled}>
        {buttonText}
      </CustomButton>
    </div>
  );
}
